import { Row, Col, Layout } from "antd";
import { LoginFormComponent } from "./form/LoginFormComponent";

const { Content } = Layout;

type LoginProps = {
  loginForm: any;
  onSubmitForm: () => void;
};

export const LoginIndexComponent = ({
  loginForm,
  onSubmitForm,
}: LoginProps) => {
  return (
    <Layout style={{ minHeight: "100vh", background: "#f1f5f9" }}>
      <Content>
        <Row style={{ minHeight: "100vh" }}>
          <Col
            xs={0}
            sm={0}
            md={10}
            lg={12}
            xl={14}
            style={{
              background: "linear-gradient(135deg, #1e293b 0%, #334155 100%)",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              padding: "40px",
              color: "#fff",
            }}
          >
            <div style={{ maxWidth: "400px", textAlign: "left" }}>
              <h1 style={{ color: "#fff", fontSize: "3rem", marginBottom: "20px" }}>
                Installment Admin
              </h1>
              <p style={{ fontSize: "1.2rem", opacity: 0.8 }}>
                Manage your installments efficiently with our modern and powerful admin dashboard.
              </p>
            </div>
          </Col>
          <Col
            xs={24}
            sm={24}
            md={14}
            lg={12}
            xl={10}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "24px",
              background: "#fff",
            }}
          >
            <div style={{ width: "100%", maxWidth: "400px" }}>
              <LoginFormComponent form={loginForm} onSubmitForm={onSubmitForm} />
            </div>
          </Col>
        </Row>
      </Content>
    </Layout>
  );
};
